module.exports = __webpack_public_path__ + "static/img/wfy.3be96b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/wfy.png
// module id = Or+e
// module chunks = 1